<template>
  <div is="div" class="menu-socialmenu-container" >
    <ul id="menu-socialmenu" class="menu">
      <li v-for="route in myRoutes" :key="route.ID"  ><a :href="route.url">{{ route.title }}</a></li>
    </ul>
  </div>
</template>
<script>
  import axios from "axios";
  export default {
    name: 'SocialMenu',
    data: () => {
      return {
        myRoutes: {},
      }
    },
    mounted () {
      this.getMenu();
    },
    computed: {

    },
    methods: {

      getMenu (){
        axios.get(
          '/menus/v1/menus/socialMenu')
        .then( (response) => {
          this.myRoutes = response.data.items;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },

  };

</script>

